import React, { useState, useEffect } from "react";
import "./Batch.scss";
import BatchTabs from "../../components/BatchTabs/BatchTabs";
import { getBatchList } from "../../util/API/batch";
import { useSelector } from "react-redux";
import { useLocation } from "react-router-dom";
import { searchAppsByLabel } from "../../util/utilfunctions/utilFunctions";
import { Box } from "@mui/material";

function Batch() {
  const [batchList, setBatchList] = useState([]);
  const [securityPermissions, setSecurityPermissions] = useState([]);

  //Security Roles
  const securityAccess = useSelector((state) => state.login.securityAccess);

  useEffect(() => {
    const securityUser = searchAppsByLabel("batch", securityAccess);

    if (securityUser.length) {
      setSecurityPermissions(securityUser[0]);
    }
  }, []);

  // Security Roles to see if batch is possible
  const batchPermissions = useSelector((state) => state.login.securityAccess);
  const path = useLocation().pathname;

  function filterLabels(data) {
    for (const item of data) {
      if (item.label.toLowerCase().includes(path.substring(1))) {
        return item;
      }
    }
  }

  //This is to get the list of batch services and set it to the state
  useEffect(() => {
    const getBatch = async () => {
      let results = await getBatchList();
      if (results.callStatus == 1) {
        if (results.payload.record.length) {
          setBatchList(results.payload.record);
        } else {
          setBatchList([results.payload.record]);
        }
      }
    };
    getBatch();
  }, []);

  const getNewBatchList = (batch) => {
    setBatchList(batch);
  };

  return (
    <Box className="page-container">
      <Box className="header-container">
        <Box className="page-title">Batch Services</Box>
      </Box>
      <Box className="batch-tabs">
        <BatchTabs
          batchList={batchList}
          userPermissions={securityPermissions}
        />
      </Box>
    </Box>
  );
}

export default Batch;
